import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const header = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;

	@media (max-width: 538px) {
		align-items: stretch;
		flex-direction: column;
	}
`;

export const listContent = styled.div`
	width: 100%;
	height: 100%;
	min-height: 30rem;
	background: ${color.interface.white};
	border-radius: 5px;
	border: 1px solid ${color.interface.lightGray4};
	overflow: auto;

	@media (max-width: 538px) {
		min-height: unset;
		border: none;
		background: transparent;
		overflow: visible;
	}
`;

export const table = styled.table`
	width: 100%;

	border-collapse: collapse;

	th,
	td {
		padding: 1.2rem;
		text-align: left;
		border-bottom: 1px solid ${color.interface.lightGray4};
		font-size: 1.3rem;
		color: ${color.interface.darkgray3};
		vertical-align: middle;
	}

	th {
		font-family: nunito-bold;
		background-color: ${color.interface.lightGray3};
	}

	@media (max-width: 538px) {
		display: block;

		thead {
			display: none;
		}

		tbody {
			display: flex;
			flex-direction: column;
			gap: 1rem;
		}

		tr {
			width: 100%;
			display: flex;
			flex-direction: column;
			border: 1px solid ${color.interface.lightGray4};
			border-radius: 5px;
			background-color: ${color.interface.white};
			overflow: hidden;
		}

		td {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 1.2rem;
			padding: 1rem 1.2rem;
			font-size: 1.2rem;
			word-break: break-word;
		}

		td::before {
			flex: 0 0 auto;
			font-family: nunito-bold;
			color: ${color.interface.lightGray};
		}

		td:nth-child(1)::before {
			content: 'Nome';
		}

		td:nth-child(2)::before {
			content: 'Tipo';
		}

		td:nth-child(3)::before {
			content: 'Status';
		}

		td:nth-child(4)::before {
			content: 'Data inicio';
		}

		td:nth-child(5)::before {
			content: 'Data termino';
		}

		td:nth-child(6)::before {
			content: 'Segmentacao';
		}

		td:nth-child(6) {
			align-items: flex-start;
			flex-direction: column;
		}

		td:nth-child(7) {
			align-items: flex-start;
			flex-direction: column;
		}

		td:nth-child(7)::before {
			content: 'Acoes';
		}
	}
`;

export const status = styled.span<{ $active: boolean }>`
	display: inline-flex;
	padding: 0.4rem 0.8rem;
	border-radius: 5px;
	color: ${color.interface.white};
	background-color: ${(props) =>
		props.$active ? color.system.success : color.interface.lightGray};
	font-size: 1.2rem;
	font-family: nunito-bold;
`;

export const type = styled.span`
	display: inline-flex;
	padding: 0.4rem 0.8rem;
	border-radius: 5px;
	background-color: ${color.interface.lightGray4};
	color: ${color.interface.darkgray3};
	font-size: 1.2rem;
	font-family: nunito-bold;
`;

export const actions = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;

	button {
		all: unset;
		cursor: pointer;
		color: ${color.interface.green2};
		font-size: 2.2rem;
		display: flex;
	}

	@media (max-width: 538px) {
		width: 100%;
		justify-content: space-between;
		gap: 0.4rem;

		button {
			width: 4rem;
			height: 3.6rem;
			align-items: center;
			justify-content: center;
			border: 1px solid ${color.interface.lightGray4};
			border-radius: 5px;
			font-size: 2rem;
		}
	}
`;

export const centralize = styled.div`
	width: 100%;
	min-height: 30rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.white};
	border-radius: 5px;
`;

export const emptyList = styled.div`
	width: 100%;
	height: 100%;
	min-height: 30rem;
	display: flex;
	align-items: center;
	justify-content: center;

	p {
		font-size: 1.5rem;
		font-family: nunito-bold;
		color: ${color.interface.lightGray};
	}

	@media (max-width: 538px) {
		min-height: 18rem;
		padding: 2rem;
		text-align: center;
		background-color: ${color.interface.white};
		border: 1px solid ${color.interface.lightGray4};
		border-radius: 5px;
	}
`;

export const PreviewImages = styled.div<{ $variant: 'COUNTDOWN' | 'SIMPLE' }>`
	width: 60vw;
	max-width: 760px;
	min-width: 320px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 800px) {
		width: 100%;
	}
`;

export const PreviewImage = styled.div`
	width: min(100%, 36rem);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;

	p {
		font-size: 1.2rem;
		font-family: nunito-bold;
		color: ${color.interface.darkgray3};
	}

	img {
		width: 100%;
		height: 24rem;
		object-fit: cover;
		border-radius: 5px;
		border: 1px solid ${color.interface.lightGray4};
		background-color: ${color.interface.lightGray3};
	}
`;

export const PreviewCarousel = styled.div`
	width: min(100%, 42rem);
	height: 28rem;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;

	> div {
		width: 100%;
		height: 100%;
	}

	img {
		border-radius: 5px;
		border: 1px solid ${color.interface.lightGray4};
		background-color: ${color.interface.lightGray3};
	}
`;
